var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',_vm._l((_vm.locales),function(locale,index){return _c('a',{key:index,staticClass:"btn text-white nav-link my-auto text-uppercase text-white p-1",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setLocale(locale)}}},[_c('img',{attrs:{"src":_vm.asset('images/' + locale + '.png'),"alt":locale}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }